<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Frame') : $t('New Frame')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.name_it"
              label="Name IT"
              v-validate="'required'"
              required
              data-vv-name="name_it"
              :error-messages="errors.collect('name_it')"
            ></v-text-field>
            <v-textarea
              v-model="formValues.description"
              label="Description"
              v-validate="'required'"
              required
              data-vv-name="description"
              :error-messages="errors.collect('description')"
            ></v-textarea>
            <v-autocomplete
              v-model="formValues.items"
              multiple
              :items="items"
              :filter="customFilter"
              :label="$t('Articles')"
              item-text="name"
              item-value="id"
              v-validate=""
              data-vv-name="subitems"
              :error-messages="errors.collect('subitems')"
              :outlined="true"
              class="mt-3"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeItem(data.item)"
                >
                  {{ data.item.code }}-{{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                {{ data.item.code }}-{{ data.item.name }}
              </template>
            </v-autocomplete>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'frame.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
import { fetchItems } from "../../items/shared/services";
export default {
  name: "app-frame-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: "",
        items: []
      },
      items: [],
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
      fetchItems().then(res => {
        this.items = res.data;
      });
    } else {
      fetchItems().then(res => {
        this.items = res.data;
        this.loading = false;
      });
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "frame.index" });
      }
    },
    removeItem(item) {
      this.formValues.items = this.formValues.items.filter(
        _item => _item != item.id
      );
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.code.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
